import axios from '@/extra-functions/axios.extra'
import Echo from 'laravel-echo'
import { authAxios } from '../extra-functions/axios.extra'
import { v1 } from 'uuid'
// import md5 from 'md5'

window.Pusher = require('pusher-js')

// const store = new Store()

export const echoSettings = (function () {
  if (process.env.NODE_ENV === 'production') {
    return {
      authEndpoint: `https://${process.env.VUE_APP_SERVER_DNS}/api/broadcasting/auth`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      broadcaster: 'pusher',
      encrypted: true,
      cluster: 'mt1',
      key: process.env.VUE_APP_WEBSOCKETS_KEY,
      wsHost: process.env.VUE_APP_WEBSOCKETS_SERVER,
      wsPort: 6001,
      forceTLS: true,
      disableStats: true,
      enabledTransports: ['ws', 'wss'],
      scheme: 'https',
    }
  }
  return {
    authEndpoint: `http://${process.env.VUE_APP_SERVER_DNS}/api/broadcasting/auth`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    broadcaster: 'pusher',
    encrypted: false,
    cluster: 'mt1',
    key: process.env.VUE_APP_WEBSOCKETS_KEY,
    wsHost: process.env.VUE_APP_SERVER_DNS,
    wsPort: 6001,
    forceTLS: false,
    disableStats: false,
    scheme: 'http',
  }
})()

const state = {
  echo: null,
  secretKey: null,
  resetTime: null,
  listenerCallbacks: new Map([]),
}

const mutations = {
  INIT_ECHO(state) {
    state.echo = new Echo({
      ...echoSettings,
      authorizer: (channel) => ({
        authorize: async (socketId, callback) => {
          try {
            const response = await authAxios().post('/broadcasting/auth', {
              socket_id: socketId,
              channel_name: channel.name,
            })
            callback(false, response.data)
          } catch (e) {
            callback(true, e)
          }
        },
      }),
    })
  },
  RESET_ECHO(state) {
    state.echo = new Echo({
      ...echoSettings,
      authorizer: (channel) => ({
        authorize: async (socketId, callback) => {
          try {
            const response = await authAxios().post('/broadcasting/auth', {
              socket_id: socketId,
              channel_name: channel.name,
            })
            callback(false, response.data)
          } catch (e) {
            callback(true, e)
          }
        },
      }),
    })
    state.resetTime = new Date().getTime()
  },
  SET_SECRET_KEY(state, payload) {
    state.secretKey = payload
  },
  ATTACH_TO_LISTENER(state, [id, event, callback]) {
    state.listenerCallbacks.set(id, {
      event,
      callback,
    })
  },
  DETACH_FROM_LISTENER(state, [id]) {
    state.listenerCallbacks.delete(id)
  },
}

const actions = {
  initEcho({ commit, state, dispatch }, [token]) {
    commit('INIT_ECHO')
    dispatch('setToken', token)
    state.echo.private('database.event')
      .listen('DBStoreEvent', (e) => {
        state.listenerCallbacks.forEach((val) => {
          const { event, callback } = val || {}
          if (!event) throw new Error('Error event of websocket listener is empty')
          callback?.(e)
        })
      })
      .listen('DBUpdateEvent', e => {
        state.listenerCallbacks.forEach((val) => {
          const { event, callback } = val || {}
          if (!event) throw new Error('Error event of websocket listener is empty')
          callback?.(e)
        })
      })
      .listen('DBDeleteEvent', e => {
        state.listenerCallbacks.forEach((val) => {
          const { event, callback } = val || {}
          if (!event) throw new Error('Error event of websocket listener is empty')
          callback?.(e)
        })
      })
  },
  attachToListener({ commit }, [event, callback]) {
    const id = v1()
    commit('ATTACH_TO_LISTENER', [id, event, callback])
    return id
  },
  detachFromListener({ commit }, [id]) {
    commit('DETACH_FROM_LISTENER', [id])
  },
  resetEcho({ commit, state }) {
    commit('RESET_ECHO')
  },
  checkSocket({ commit }) {
    const ax = axios(null)
    const secretKey = (new Date().getTime())
    ax.get(`socket-check/${secretKey}`)
  },
  setToken({ state }, payload) {
    if (!payload) return
    state.echo.connector.pusher.config.auth.headers.Authorization = `Bearer ${payload}`
  },
}

export default {
  namespaced: true,
  strict: true,
  state,
  mutations,
  actions,
}
